export default __webpack_public_path__ + "static/media/rocket.00a687f3.svg";